import type {
  Category,
  RsuiteItemDataTypeConverterFn
} from '@@partner:types:app'

export const convertCategoryToItemDataType: RsuiteItemDataTypeConverterFn<Category> =
  (category: Category) => ({
    label: category.name,
    value: category.id,
    children: [],
    loading: false,
    parent_id: category.parent_id,
    __category: category
  })
